import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-iconPark-pesticide",
  "use": "icon-iconPark-pesticide-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-iconPark-pesticide\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 11.3684V4H24H33V11.3684L39 17.4868V19.5263V27.6842V42C39 43.1046 38.1046 44 37 44H11C9.89543 44 9 43.1046 9 42V27.6842V19.5263V17.4868L15 11.3684Z\" fill=\"none\" stroke=\"#333\" stroke-width=\"4\" stroke-linejoin=\"round\" /><path d=\"M9 23H17V35H9\" stroke=\"#333\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M15 11.5H33\" stroke=\"#333\" stroke-width=\"4\" stroke-linecap=\"round\" /><path d=\"M31 23V29\" stroke=\"#333\" stroke-width=\"4\" stroke-linecap=\"round\" /><path d=\"M31 34V35\" stroke=\"#333\" stroke-width=\"4\" stroke-linecap=\"round\" /><path d=\"M9 38V20\" stroke=\"#333\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/iconPark-pesticide.svg
// module id = ZWtJ
// module chunks = 24